"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBillsResponseToJSON = exports.GetBillsResponseFromJSONTyped = exports.GetBillsResponseFromJSON = exports.instanceOfGetBillsResponse = void 0;
var runtime_1 = require("../runtime");
var Bill_1 = require("./Bill");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the GetBillsResponse interface.
 */
function instanceOfGetBillsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetBillsResponse = instanceOfGetBillsResponse;
function GetBillsResponseFromJSON(json) {
    return GetBillsResponseFromJSONTyped(json, false);
}
exports.GetBillsResponseFromJSON = GetBillsResponseFromJSON;
function GetBillsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bills': !(0, runtime_1.exists)(json, 'bills') ? undefined : (json['bills'].map(Bill_1.BillFromJSON)),
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
    };
}
exports.GetBillsResponseFromJSONTyped = GetBillsResponseFromJSONTyped;
function GetBillsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bills': value.bills === undefined ? undefined : (value.bills.map(Bill_1.BillToJSON)),
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
    };
}
exports.GetBillsResponseToJSON = GetBillsResponseToJSON;
